export class SessionManager {
  constructor() {
    this.session = null;
    this.currentCommandName = null;
  }

  startSession(commandName, command, initialData = {}) {
    this.currentCommandName = commandName;
    this.session = {
      name: commandName,
      stepIndex: 0,
      data: initialData,
      command,
      promptedStepHistory: [],
    };
  }

  endSession() {
    this.session = null;
    this.currentCommandName = null;
  }

  isInSession() {
    return this.session !== null;
  }

  getCurrentStep() {
    if (!this.session) return null;
    const steps = this.session.command.steps;
    const data = this.session.data || {};
    let step = steps[this.session.stepIndex];
    // Skip steps whose condition evaluates to false (conditional steps).
    // When skipping, auto-fill the step's field from _lastCreatedUuid so
    // that subprocess-created entities are captured in the session data.
    while (
      step &&
      typeof step.condition === "function" &&
      !step.condition(data)
    ) {
      if (step.field && data._lastCreatedUuid) {
        data[step.field] = data._lastCreatedUuid;
      }
      this.session.stepIndex += 1;
      step = steps[this.session.stepIndex];
    }
    return step;
  }

  moveToNextStep() {
    if (this.session) {
      this.session.stepIndex++;
    }
  }

  recordPromptedStep(stepIndex) {
    if (this.session) {
      this.session.promptedStepHistory.push(stepIndex);
    }
  }

  moveToPreviousPromptedStep() {
    if (!this.session || !this.session.promptedStepHistory.length) {
      return false;
    }
    this.session.stepIndex = this.session.promptedStepHistory.pop();
    return true;
  }

  isAtFirstPromptedStep() {
    if (!this.session) return true;
    return this.session.promptedStepHistory.length === 0;
  }

  hasMoreSteps() {
    if (!this.session) return false;
    return this.session.stepIndex < this.session.command.steps.length;
  }

  getCurrentStepIndex() {
    return this.session?.stepIndex || 0;
  }

  getTotalSteps() {
    return this.session?.command?.steps?.length || 0;
  }

  getSessionData() {
    return this.session?.data || {};
  }

  updateSessionData(key, value) {
    if (this.session) {
      if (!this.session.data) {
        this.session.data = {};
      }
      this.session.data[key] = value;
    }
  }

  // Bulk update session data
  mergeSessionData(data) {
    if (this.session && data && typeof data === "object") {
      if (!this.session.data) {
        this.session.data = {};
      }
      Object.assign(this.session.data, data);
    }
  }
}
